<template>
  <div v-if="reviews && reviews.length" class="bg-blue-primary overflow-hidden">
    <div class="yellow-square" />
    <Block :block="block.innerBlocks[0]" />
    <Block class="mb-ds-lg" :block="block.innerBlocks[1]" />
    <InternalReviewCarousel :reviews="reviews" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_INTERNAL_REVIEWS } from "~/store/internal-reviews"

export default defineComponent({
  name: "InternalReviewSection",
  props: {
    block: {
      required: true,
      type: Object as () => Block
    }
  },
  computed: {
    ...mapGetters("internal-reviews", {
      reviews: GET_INTERNAL_REVIEWS
    })
  }
})
</script>

<style lang="css" module>
:global(.av-internal-review-section) {
  &::before {
    @apply h-full w-full absolute lg:bg-[url('/content-static/wp-theme/desktop-review-seo.webp')] lg:bg-no-repeat lg:bg-[-8%_100%] lg:bg-[length:50%];
    content: "";
  }
}
</style>
